import axios from "../../../axios";

export const getSettings = async (worker_id) => {
  try {
    let { data } = await axios.get(`/v1/worker/settings?worker_id=${worker_id}`);
    return data;
  } catch (e) {
    console.log("error while getting workers setting data", e);
  }
};
